module.exports = __webpack_public_path__ + "static/media/Saint Kitts and Nevis - KN.e57f18df.png";